module.exports = __webpack_public_path__ + "img/nose-05.fe475292.svg";